/* import __COLOCATED_TEMPLATE__ from './llm-evaluation-editor.hbs'; */
/* RESPONSIBLE TEAM: team-ml */
/* eslint-disable @intercom/intercom/no-component-inheritance */
import BaseEditor from './base-editor';
export default BaseEditor.extend({});